import UserIcon from 'src/assets/img/cat-user-icon.svg'
import LoanIcon from 'src/assets/img/cat-loan-icon.svg'
import ChatIcon from 'src/assets/img/cat-chat-icon.svg'
import VerificationIcon from 'src/assets/img/cat-verification-icon.svg'

let isLive = process.env.REACT_APP_ENVIRONMENT === 'production';
console.log({environment: process.env.REACT_APP_ENVIRONMENT})

let baseUrl = isLive ? 'https://serviceproviders.qoreonline.com/api' : 'https://baap-middleware-api.qore.build/api'

export const url = {
    AUTH_BASE_URL: `${baseUrl}/auth/v1`,
    ADMIN_BASE_URL: `${baseUrl}/admin/v1`,
    BILLING_BASE_URL: `${baseUrl}/bill/v1`,
    PRODUCT_BASE_URL: `${baseUrl}/prod/v1`,
    SSO_URL: isLive ? 'https://sso.qore.inc/' : 'https://sso.qore.build/'
} 

export const appSettings = {
    BACKGROUND_JOB_WAIT_TIME: 5 * 1000,
    TOKEN_REFRESH_TIME: 14 * 1000 * 60
}

export const categoryMap: any = {
    13: {bgColor: '#D9FFFC', iconBgColor: '#3EDCCF', icon: UserIcon},
    1: {bgColor: '#FECAFF', iconBgColor: '#FC81FF', icon: ChatIcon},
    3: {bgColor: '#CCFFBB' , iconBgColor: '#79D05D', icon: VerificationIcon},
    2: {bgColor: '#D8D8FF', iconBgColor: '#8888FF', icon: LoanIcon},
    11: {bgColor: '#C7C7C8', iconBgColor: '#919192', icon: LoanIcon},
    8: {bgColor: '#FECAFF', iconBgColor: '#FC81FF', icon: ChatIcon},
    7: {bgColor: '#CCFFBB' , iconBgColor: '#79D05D', icon: VerificationIcon}
}

export const availabilityMap: any = {
    Available: {bgColor: '#CCFFBB !important', iconBgColor: '#79D05D'},
    null: {bgColor: '#C7C7C8 !important', iconBgColor: '#919192'},
    notAvailable: {bgColor: '#C7C7C8 !important', iconBgColor: '#919192'}
}


export const CONSTANTs = {
    qoreAccountNumber: process.env.REACT_APP_ACCOUNT_NUMBER || '2042710705',
    qoreBank: process.env.REACT_APP_QORE_BANK || 'First Bank of Nigeria',
    qoreAccountName: process.env.REACT_APP_QORE_ACCOUNT_NAME || 'Qore technologies limited',
    clientId: isLive ? '9f8a7c2e-83b4-4c97-8d3e-27d91a1f4e61' : 'b6f5c7a1-4e53-4c2e-b519-13e1b9e6e9dc',
    secretKey: isLive ? 'P@5$gL!e7Vwq#bZr3XmN^KdLpQ8uYrT2sMjA9tHc' : 'xZ8$kq2@Lm1#rPh0!Va4Tf9gDqzE3mWx',
    adminUserCreationRoleId: isLive ? '1' : '4'
}